import { FC, PropsWithChildren, useEffect, useMemo } from "react";

import Loading from "../Common/LoadingNew";
import getRedirectData from "./utils/getRedirectData";

const REDIRECT_DELAY = 3000;

const RedirectToNativeStore: FC<PropsWithChildren> = ({ children }) => {
  const { willRedirectToStore, url } = useMemo(getRedirectData, []);

  useEffect(() => {
    if (!url) {
      return undefined;
    }

    if (willRedirectToStore) {
      const timeoutId = window.setTimeout(() => {
        window.location.href = url as string;
      }, REDIRECT_DELAY);

      return () => window.clearTimeout(timeoutId);
    }

    window.location.href = url;
    return undefined;
  }, [url, willRedirectToStore]);

  if (!willRedirectToStore && !url) {
    return <>{children}</>;
  }

  if (willRedirectToStore) {
    return <Loading />;
  }

  return null;
};

export default RedirectToNativeStore;
